<section class="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 animate-fade-in relative z-10 pb-24">
  
  <div class="flex flex-col gap-8">
    
    <!-- Single Full-Width Column -->
    <div class="w-full">
      
      <!-- Back button -->
      <button (click)="goBack()" class="flex items-center gap-2 text-sm font-bold text-text-muted hover:text-white transition-colors mb-6 cursor-pointer">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
        Back to Pools
      </button>

      <!-- Header -->
      <div class="flex flex-col lg:flex-row lg:items-center justify-between mb-8 gap-4">
        <div class="flex flex-wrap items-center gap-3 md:gap-4">
          <div class="flex -space-x-2">
            <div class="w-[42px] h-[42px] rounded-full flex items-center justify-center text-white border-[3px] border-[#0c0c0c] z-10 shadow-md font-bold text-lg overflow-hidden bg-[#0c0c0c]">
              <ng-container *ngIf="token1Logo; else t1Fallback">
                <img [src]="token1Logo" [alt]="token1" class="w-full h-full object-cover bg-white">
              </ng-container>
              <ng-template #t1Fallback>
                <div class="w-full h-full flex items-center justify-center" [style.background]="token1Color">
                  {{ token1[0] }}
                </div>
              </ng-template>
            </div>
            <div class="w-[42px] h-[42px] rounded-full flex items-center justify-center text-white border-[3px] border-[#0c0c0c] shadow-md font-bold text-lg overflow-hidden bg-[#0c0c0c]">
              <ng-container *ngIf="token2Logo; else t2Fallback">
                <img [src]="token2Logo" [alt]="token2" class="w-full h-full object-cover bg-white">
              </ng-container>
              <ng-template #t2Fallback>
                <div class="w-full h-full flex items-center justify-center" [style.background]="token2Color">
                  {{ token2[0] }}
                </div>
              </ng-template>
            </div>
          </div>
          <h1 class="font-display font-black text-2xl text-white tracking-wide">{{ poolName }}</h1>
          <span class="text-[12px] font-bold bg-white/5 border border-white/10 px-2.5 py-1 rounded-md text-text-muted">0.05% Fee Tier</span>
          <div class="flex items-center gap-1.5 px-2.5 py-1 bg-[#20d489]/10 rounded-md">
            <div class="w-1.5 h-1.5 rounded-full bg-[#20d489]"></div>
            <span class="text-[12px] font-bold text-[#20d489]">Active</span>
          </div>
        </div>
        
        <!-- Header Actions -->
        <div class="flex flex-wrap items-center gap-3 mt-4 lg:mt-0">
          <button (click)="goToAddLiquidity()" class="px-5 py-2.5 rounded-lg bg-gold text-black text-[13px] font-extrabold shadow-[0_0_15px_rgba(245,183,59,0.2)] hover:bg-gold/90 transition-all flex items-center gap-1.5 whitespace-nowrap">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" /></svg>
            Add Liquidity
          </button>
          <button (click)="goToSwap()" class="px-5 py-2.5 rounded-lg bg-white/5 border border-white/10 text-white text-[13px] font-bold hover:bg-white/10 transition-all flex items-center gap-1.5">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" /></svg>
            Swap
          </button>
          <div class="w-px h-6 bg-white/10 mx-1 hidden lg:block"></div>
          <button type="button" (click)="toggleWatchlist()" class="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-transparent border border-white/10 text-[13px] font-bold text-white hover:bg-white/5 transition-colors">
            <svg [ngClass]="isWatchlisted ? 'text-gold fill-gold' : 'text-text-dim fill-none'" class="w-4 h-4" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"></path></svg>
            <span class="hidden sm:inline">Watchlist</span>
          </button>
          <button type="button" (click)="copyLink()" class="w-10 h-10 flex items-center justify-center rounded-lg bg-transparent border border-white/10 text-white hover:bg-white/5 transition-colors">
            <svg class="w-4 h-4 text-text-dim" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"></path></svg>
          </button>
        </div>
      </div>

      <!-- Quick Stats Row -->
      <div class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-6">
        <div>
          <div class="text-[11px] font-bold text-text-muted mb-1.5 uppercase tracking-wider">APR</div>
          <div class="text-[20px] font-black text-[#20d489]">{{ apr }}</div>
        </div>
        <div>
          <div class="text-[11px] font-bold text-text-muted mb-1.5 uppercase tracking-wider">TVL</div>
          <div class="text-[20px] font-black text-white">{{ tvl }}</div>
        </div>
        <div>
          <div class="text-[11px] font-bold text-text-muted mb-1.5 uppercase tracking-wider">Volume (24H)</div>
          <div class="text-[20px] font-black text-white">{{ volume24h }}</div>
        </div>
        <div>
          <div class="text-[11px] font-bold text-text-muted mb-1.5 uppercase tracking-wider">Fees (24H)</div>
          <div class="text-[20px] font-black text-white">{{ fees24h }}</div>
        </div>
        <div>
          <div class="text-[11px] font-bold text-text-muted mb-1.5 uppercase tracking-wider">Current Price</div>
          <div class="text-[15px] font-bold text-white mt-1.5">{{ currentPrice }}</div>
        </div>
      </div>

      <!-- Chart Container -->
      <div class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl mb-6">
        <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          <div class="flex gap-1 bg-[#121212]/80 backdrop-blur-md border border-white/[0.08] rounded-xl p-1 shadow-inner overflow-x-auto whitespace-nowrap hide-scrollbar w-full md:w-auto">
            @for (metric of metrics; track metric) {
              <button 
                (click)="setMetric(metric)"
                class="px-4 py-1.5 rounded-lg text-[12px] font-bold transition-all tracking-wide shrink-0"
                [ngClass]="activeMetric === metric ? 'bg-white/10 text-gold shadow-[0_2px_10px_rgba(0,0,0,0.5)] border border-white/[0.05]' : 'text-text-muted hover:text-white'">
                {{ metric }}
              </button>
            }
          </div>
          <div class="flex gap-1 overflow-x-auto whitespace-nowrap hide-scrollbar w-full md:w-auto">
            @for (filter of timeFilters; track filter) {
              <button 
                (click)="setTimeFilter(filter)"
                class="px-3 py-1.5 rounded-lg text-[12px] font-bold transition-all shrink-0"
                [ngClass]="activeTimeFilter === filter ? 'bg-white/10 text-white border border-white/[0.05]' : 'text-text-muted hover:text-white'">
                {{ filter }}
              </button>
            }
          </div>
        </div>
        <!-- ECharts Area -->
        <div class="h-[320px] w-full relative">
          <div #chartContainer class="w-full h-full absolute inset-0 z-10"></div>
        </div>
      </div>

      <!-- Overview / Tabs Section -->
      <div class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl">
        <!-- Tabs Nav -->
        <div class="flex gap-6 border-b border-white/10 mb-6 pb-4 overflow-x-auto whitespace-nowrap hide-scrollbar">
          @for (tab of contentTabs; track tab) {
            <button 
              (click)="activeContentTab = tab"
              class="text-[14px] font-bold pb-4 -mb-[18px] transition-colors"
              [ngClass]="activeContentTab === tab ? 'text-gold border-b-2 border-gold' : 'text-text-muted hover:text-white'">
              {{ tab }}
            </button>
          }
        </div>
        
        <!-- Tab Content -->
        
        @if (activeContentTab === 'Overview') {
          <!-- Overview Grid -->
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6 text-[13px] font-medium text-text-muted animate-fade-in">
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Pool Address</span>
               <span class="text-gold cursor-pointer flex items-center gap-1.5">{{ address }} <svg class="w-3.5 h-3.5 text-text-dim" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path></svg></span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Total Liquidity</span>
               <span class="text-white font-bold">{{ tvl }}</span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Token 0</span>
               <span class="text-white font-bold flex items-center gap-1.5">
                 <div *ngIf="!token1Logo" class="w-4 h-4 rounded-full flex items-center justify-center text-[10px]" [style.background]="token1Color">
                   {{ token1[0] }}
                 </div>
                 <img *ngIf="token1Logo" [src]="token1Logo" class="w-4 h-4 rounded-full" alt="Token 1">
                 {{ token1 }}
               </span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>24H Volume</span>
               <span class="text-white font-bold">{{ volume24h }}</span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Token 1</span>
               <span class="text-white font-bold flex items-center gap-1.5">
                 <div *ngIf="!token2Logo" class="w-4 h-4 rounded-full flex items-center justify-center text-[10px]" [style.background]="token2Color">
                   {{ token2[0] }}
                 </div>
                 <img *ngIf="token2Logo" [src]="token2Logo" class="w-4 h-4 rounded-full" alt="Token 2">
                 {{ token2 }}
               </span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>24H Fees</span>
               <span class="text-white font-bold">{{ fees24h }}</span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Fee Tier</span>
               <span class="text-white font-bold">{{ selectedFeeTier }}</span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>APR</span>
               <span class="text-white font-bold">{{ apr }}</span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Protocol Fee</span>
               <span class="text-white font-bold">{{ protocolFee }}</span>
             </div>
             <div class="flex justify-between items-center py-2 border-b border-white/[0.02]">
               <span>Price Range</span>
               <span class="text-white font-bold">Full Range</span>
             </div>
          </div>
        }

        @if (activeContentTab === 'Transactions') {
          <div class="overflow-x-auto animate-fade-in">
            <table class="w-full text-left">
              <thead>
                <tr class="text-[11px] font-bold text-text-muted uppercase tracking-wider border-b border-white/5">
                  <th class="pb-3 pr-4">Time</th>
                  <th class="pb-3 pr-4">Type</th>
                  <th class="pb-3 pr-4">Total Value</th>
                  <th class="pb-3 pr-4 hidden sm:table-cell">Token Amount 1</th>
                  <th class="pb-3 pr-4 hidden sm:table-cell">Token Amount 2</th>
                  <th class="pb-3 hidden md:table-cell">Account</th>
                </tr>
              </thead>
              <tbody>
                @for (tx of transactions; track tx) {
                  <tr class="border-b border-white/[0.03] hover:bg-white/[0.02] transition-colors">
                    <td class="py-3 pr-4 text-[13px] text-text-dim whitespace-nowrap">{{ tx.time }}</td>
                    <td class="py-3 pr-4 text-[13px] font-bold whitespace-nowrap" [ngClass]="tx.typeColor">{{ tx.type }}</td>
                    <td class="py-3 pr-4 text-[13px] font-bold text-white whitespace-nowrap">{{ tx.usd }}</td>
                    <td class="py-3 pr-4 text-[13px] text-text-dim hidden sm:table-cell whitespace-nowrap">{{ tx.t1 }} {{ token1 }}</td>
                    <td class="py-3 pr-4 text-[13px] text-text-dim hidden sm:table-cell whitespace-nowrap">{{ tx.t2 }} {{ token2 }}</td>
                    <td class="py-3 text-[13px] text-gold hover:underline cursor-pointer hidden md:table-cell whitespace-nowrap">{{ tx.wallet }}</td>
                  </tr>
                }
              </tbody>
            </table>

            <!-- Pagination Controls -->
            <!-- Pagination Footer -->
            <div class="flex flex-col sm:flex-row items-center justify-between py-4 px-6 mt-6 border-t border-white/[0.05]">
              <div class="text-[12px] font-bold text-text-muted mb-4 sm:mb-0">
                Showing {{ totalRecords === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1 }} to {{ Math.min(currentPage * itemsPerPage, totalRecords) }} of {{ totalRecords }} transactions
              </div>

              <div class="flex flex-wrap items-center justify-center gap-2 mb-4 sm:mb-0" *ngIf="totalPages > 1">
                <button (click)="prevPage()" [disabled]="currentPage === 1"
                  class="w-7 h-7 flex items-center justify-center rounded bg-white/[0.03] text-text-dim hover:text-white disabled:opacity-50 transition-colors"><svg
                    class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                  </svg></button>

                @for (page of paginationPages; track $index) {
                  @if (page === '...') {
                    <span class="text-text-dim text-[12px] font-bold mx-1">...</span>
                  } @else {
                    <button (click)="goToPage(page)"
                      class="w-7 h-7 flex items-center justify-center rounded font-bold text-[12px] transition-colors"
                      [ngClass]="page === currentPage ? 'bg-gold text-black font-extrabold shadow-[0_0_10px_rgba(245,183,59,0.2)]' : 'bg-white/[0.03] text-text-muted hover:text-white hover:bg-white/[0.05]'">
                      {{ page }}
                    </button>
                  }
                }

                <button (click)="nextPage()" [disabled]="currentPage === totalPages"
                  class="w-7 h-7 flex items-center justify-center rounded bg-white/[0.03] text-text-dim hover:text-white disabled:opacity-50 transition-colors"><svg
                    class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                  </svg></button>
              </div>

              <div class="hidden md:flex items-center gap-2 text-[12px] font-bold text-text-muted">
                Rows per page:
                <div class="relative">
                  <select [(ngModel)]="itemsPerPage" (ngModelChange)="loadTransactions(1)"
                    class="bg-[#0c0c0c] border border-white/10 rounded py-1 pl-2 pr-6 outline-none appearance-none cursor-pointer">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="20">20</option>
                    <option [ngValue]="50">50</option>
                  </select>
                  <svg class="absolute right-1.5 top-1/2 -translate-y-1/2 w-3 h-3 text-gold pointer-events-none" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        }

        @if (activeContentTab === 'Holders') {
          <div class="py-12 flex flex-col items-center justify-center text-center animate-fade-in">
            <div class="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4">
              <svg class="w-8 h-8 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
            </div>
            <h3 class="text-white font-bold text-lg mb-2">Holder Distribution</h3>
            <p class="text-text-muted text-sm max-w-sm">Data regarding individual liquidity providers and their pool shares is currently syncing.</p>
          </div>
        }

        @if (activeContentTab === 'Analytics') {
          <div class="py-12 flex flex-col items-center justify-center text-center animate-fade-in">
            <div class="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4">
              <svg class="w-8 h-8 text-text-dim" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
            </div>
            <h3 class="text-white font-bold text-lg mb-2">Advanced Analytics</h3>
            <p class="text-text-muted text-sm max-w-sm">Historical analytics and yield projections are available for pro tier users.</p>
          </div>
        }

      </div>

    </div>
  </div>
</section>
